import AxiosStatic from 'axios';

import { PrizeData } from '../types/prize.types';
import { API_ENDPOINTS } from '../constants/api';
import axios from './client';

export interface PrizeApiResponse {
    Status: string;
    data: PrizeData;
}

export class PrizeService {
    static async getPrizes(): Promise<PrizeData> {
        try {
            const response = await axios.get<PrizeApiResponse>(API_ENDPOINTS.GET_PRIZES);

            if (response.data.Status === 'OK') {
                return response.data.data;
            } else {
                throw new Error('Failed to fetch prizes:');
            }
        } catch (error) {
            if (AxiosStatic.isAxiosError(error)) {
                throw new Error(`request failed: ${error.message}`);
            }
            throw new Error('Unknown error occurred');
        }
    }
}
